import {
  BLOCK_TYPE_OPTIONS,
  SECTION_CODE_OPTIONS,
  TAB_CODE_OPTIONS,
} from 'constants/block-options';

function returnMasteryData(masteryData, blockDataList) {
  const blockMap = new Map();

  masteryData.forEach(sheet => {
    const { block, is_hidden: isHidden } = sheet;

    if (!block || !block.id || isHidden) {
      return;
    }

    let updatedBlock = {};

    if (blockMap.has(block.id)) {
      updatedBlock = blockMap.get(block.id);
      updatedBlock.sheets.push(sheet);
    } else {
      updatedBlock = { ...block };
      updatedBlock.sheets = [sheet];
    }
    blockMap.set(block.id, updatedBlock);
  });

  blockDataList &&
    blockDataList.length > 0 &&
    blockDataList
      // .filter(
      //   blockData =>
      //     blockData.tab_code !== TAB_CODE_OPTIONS.PUZZLE_CARDS &&
      //     blockData.section_code !== SECTION_CODE_OPTIONS.PUZZLE_CARDS &&
      //     blockData.block_type !== BLOCK_TYPE_OPTIONS.PUZZLE_CARDS,
      // )
      .forEach(blockData => {
        let updatedBlock = {};

        if (blockMap.has(blockData.id)) {
          updatedBlock = blockMap.get(blockData.id);
        } else {
          updatedBlock = { ...blockData };
          updatedBlock.sheets = [];
        }

        blockMap.set(blockData.id, updatedBlock);
      });

  const sectionMap = new Map();

  // eslint-disable-next-line
  for (let block of blockMap.values()) {
    const { section_code: sectionCode } = block;
    let sectionBlocks = [];

    if (sectionMap.has(sectionCode)) {
      sectionBlocks = sectionMap.get(sectionCode);
      sectionBlocks.push(block);
    } else {
      sectionBlocks.push(block);
    }
    sectionMap.set(sectionCode, sectionBlocks);
  }

  let outputData = [];
  for (const key of sectionMap) {
    let [section_code, details] = key;
    details.map(itemInfo => {
      let tempItemInfo = [...itemInfo.sheets];
      if (tempItemInfo.length > 0) {
        tempItemInfo = tempItemInfo.sort((a, b) => a.position - b.position);
        // .map((nodeData, index) => (nodeData.position = index + 1));
      }
      return tempItemInfo;
    });
    const obj = { section_code, block: details };
    outputData.push(obj);
  }

  return outputData;
}

function returnPuzzleData(puzzleData, blockDataList) {
  const puzzleBlockMap = new Map();

  puzzleData.forEach(sheet => {
    const { block, is_hidden: isHidden } = sheet;

    if (!block || !block.id || isHidden) {
      return;
    }

    let updatedBlock = {};

    if (puzzleBlockMap.has(block.id)) {
      updatedBlock = puzzleBlockMap.get(block.id);
      updatedBlock.sheets.push(sheet);
    } else {
      updatedBlock = { ...block };
      updatedBlock.sheets = [sheet];
    }
    puzzleBlockMap.set(block.id, updatedBlock);
  });

  blockDataList &&
    blockDataList.length > 0 &&
    blockDataList
      .filter(
        blockData =>
          blockData.tab_code === TAB_CODE_OPTIONS.PUZZLE_CARDS &&
          blockData.section_code === SECTION_CODE_OPTIONS.PUZZLE_CARDS &&
          blockData.block_type === BLOCK_TYPE_OPTIONS.PUZZLE_CARDS,
      )
      .forEach(blockData => {
        let updatedBlock = {};

        if (puzzleBlockMap.has(blockData.id)) {
          updatedBlock = puzzleBlockMap.get(blockData.id);
        } else {
          updatedBlock = { ...blockData };
          updatedBlock.sheets = [];
        }

        puzzleBlockMap.set(blockData.id, updatedBlock);
      });

  const puzzleSectionMap = new Map();

  // eslint-disable-next-line
  for (let block of puzzleBlockMap.values()) {
    const { section_code: sectionCode } = block;
    let sectionBlocks = [];

    if (puzzleSectionMap.has(sectionCode)) {
      sectionBlocks = puzzleSectionMap.get(sectionCode);
      sectionBlocks.push(block);
    } else {
      sectionBlocks.push(block);
    }
    puzzleSectionMap.set(sectionCode, sectionBlocks);
  }

  let outputData = [];
  for (const key of puzzleSectionMap) {
    let [section_code, details] = key;
    details.map(itemInfo => {
      let tempItemInfo = [...itemInfo.sheets];
      if (tempItemInfo.length > 0) {
        tempItemInfo = tempItemInfo.sort((a, b) => a.position - b.position);
        // .map((nodeData, index) => (nodeData.position = index + 1));
      }
      return tempItemInfo;
    });
    const obj = { section_code, block: details };
    outputData.push(obj);
  }

  return outputData;
}

/* 
  This function is used to segregate data based on blocks among sheets. 
  typeof chapter and blockDataList is Array.
*/
export const activityUtils = (chapter, blockDataList) => {
  if (!chapter) return null;

  const masteryData =
    chapter && chapter.length
      ? // ? chapter.filter(puzzle => puzzle.block.tab_code !== TAB_CODE_OPTIONS.PUZZLE_CARDS)
        chapter
      : [];

  const puzzleData =
    chapter && chapter.length
      ? chapter.filter(
          puzzle =>
            puzzle.block.tab_code === TAB_CODE_OPTIONS.PUZZLE_CARDS &&
            puzzle.block.section_code === SECTION_CODE_OPTIONS.PUZZLE_CARDS &&
            puzzle.block.block_type === BLOCK_TYPE_OPTIONS.PUZZLE_CARDS,
        )
      : [];

  let masteryCardData = returnMasteryData(masteryData, blockDataList);
  const puzzleCardData = returnPuzzleData(puzzleData, blockDataList);

  masteryCardData = masteryCardData.map(
    cardData =>
      cardData && {
        section_code: cardData.section_code,
        emptyBlock:
          cardData.block &&
          cardData.block.filter(blockData => blockData.sheets.length === 0),
        block:
          cardData.block &&
          cardData.block.filter(blockData => blockData.sheets.length !== 0),
      },
  );

  return { masteryCardData, puzzleCardData };
};

/* This function is used to separate old and new data from a common list. */
export const incomingNewSheetSeparator = (engine, blockDataList) => {
  let nodeData = {};
  let newSheetData = {};

  const NODES = engine.diagramModel.nodes;

  Object.entries(NODES).forEach(([nodesKey, nodesData]) => {
    const { activityNodeData } = nodesData || {};

    if (nodesData.activityNodeData.block) {
      nodeData[nodesKey] = activityNodeData;
    } else {
      newSheetData[nodesKey] = activityNodeData;
    }
  });

  const nodeDataList = activityUtils(Object.values(nodeData), blockDataList);
  const extraSheetList = Object.values(newSheetData);

  return { nodeDataList, extraSheetList };
};

/* This function is used to assign block to a sheet. */
export const assignBlockToSheet = (blockData, engine, selectedNodeID) => {
  let NODES = engine.diagramModel.nodes;
  if (Array.isArray(selectedNodeID)) {
    selectedNodeID.forEach(nodeId => (NODES[nodeId].activityNodeData.block = blockData));
  } else if (NODES[selectedNodeID]) {
    NODES[selectedNodeID].activityNodeData.block = blockData;
  }

  return engine;
};

/* This functions Gives sheets of particular block based on block id */

export const separateSheetDataFromBlock = blockDataList => {
  const temp = blockDataList.map(item => item.block);
  const temp2 = [];
  temp.forEach(item => item.forEach(el => el.sheets.length > 0 && temp2.push(el.sheets)));

  const sheetData = [];
  temp2.forEach(item => item.forEach(el => sheetData.push(el)));

  return sheetData;
};
